import { Divider, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { getRecvQtyLog } from "services/data.inbound.service";
import MDBadge from "components/MDBadge";

function RecvQtyLog({ open, setOpen, logRequest, setLogRequest }) {
  const columns = [
    { label: "SKU Code", id: "skuCode" },
    { label: "Quantity", id: "quantity" },
    { label: "Carton Id", id: "cartonId" },
    { label: "MLN", id: "mln" },
    { label: "Expiry Date", id: "expiryDate" },
    { label: "To Zone", id: "toZone" },
    { label: "To Location", id: "toLocation" },
  ];
  const { data } = useQuery({
    queryKey: ["recv-qty-log", { logRequest }],
    queryFn: () => getRecvQtyLog(logRequest),
    enabled: Boolean(logRequest),
  });

  const details = data?.data.data.details;

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Recv Qty Scan
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(data) && (
        <>
          <MDBox style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Recv Code : </b>
                {logRequest.recvCode}
              </Grid>
              <Grid item xs={6}>
                <b>Status : </b>
                {logRequest.canPalletize ? (
                  <MDBadge
                    variant="gradient"
                    color="success"
                    size="xs"
                    badgeContent="Complete"
                    container
                  />
                ) : (
                  <MDBadge
                    variant="gradient"
                    color="warning"
                    size="xs"
                    badgeContent="Scanning"
                    container
                  />
                )}
              </Grid>
            </Grid>
          </MDBox>
          <StickyHeadTable columns={columns} rows={details} />
        </>
      )}
    </Drawer>
  );
}

export default RecvQtyLog;
